import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation SetRoutingSettings(
                          $operatorId: Int!,
                          $updateSkills: [UpdateSkillInput!],
                          $updateChannelsInput: [UpdateOperatorChannelInput!],
                          $updateActivitiesLimitInput: [UpdateGroupActivitiesLimitInput!]
                          $updateOperatorExpressInput: [UpdateOperatorExpressInput]
                        ) {
  SetRoutingSettings(
    updateSkills: $updateSkills,
    operatorId: $operatorId,
    updateChannelsInput: $updateChannelsInput,
    updateActivitiesLimitInput: $updateActivitiesLimitInput,
    updateOperatorExpressInput: $updateOperatorExpressInput,
  )
}`;

function setOperatorSettings(opts) {
  const {
    operatorId,
    updateSkills,
    updateChannelsInput,
    updateActivitiesLimitInput,
    updateOperatorExpressInput,
  } = opts;
  return apollo.client.mutate({
    variables: {
      operatorId,
      updateSkills,
      updateChannelsInput,
      updateActivitiesLimitInput,
      updateOperatorExpressInput,
    },
    mutation,
  }).then((res) => res.data);
}

export default setOperatorSettings;
